export default __webpack_public_path__ + "static/media/NewUserIcon.44154379.svg";